import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "oil-finder" };
const _hoisted_2 = { key: 0 };
import { useStep } from '../composables/useStep';
import VehicleTypesList from './ui/VehicleTypesList.vue';
import SearchTabPanels from './ui/SearchTabPanels.vue';
import VehicleDetailsHeader from './ui/VehicleDetailsHeader.vue';
import RecommendedVehicleComponents from './ui/RecommendedVehicleComponents.vue';
import InfoMessage from './ui/InfoMessage.vue';
import StaticBanner from './StaticBanner.vue';
import StaticBannerWithCTA from './StaticBannerWithCTA.vue';
import FindYourNearestStockistMap from './ui/FindYourNearestStockistMap.vue';
import { onMounted, ref } from 'vue';
import { useOilFinder } from '../composables/useOilFinder';
import { useVehicleDetails } from '../composables/useVehicleDetails';
import { useVehicleComponents } from '../composables/useVehicleComponents';
const VEHICLE_KEY = 'selectedVehicleId';
const LICENCE_PLATE_KEY = 'selectedLicencePlate';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OilFinder',
    setup(__props) {
        const { step, goToStep } = useStep();
        const { api } = useOilFinder();
        const { setVehicleDetails, setLicencePlate } = useVehicleDetails();
        const { setVehicleComponents } = useVehicleComponents();
        // Add a key to force re-render when vehicle changes
        const vehicleKey = ref(0);
        onMounted(async () => {
            if (step.value === 1) {
                // Check for stored vehicle selection from previous page
                const storedVehicleId = localStorage.getItem(VEHICLE_KEY);
                const storedLicencePlate = localStorage.getItem(LICENCE_PLATE_KEY);
                // Only automatically process the vehicle if we're on /find-my-oil page
                if (storedVehicleId) {
                    // Restore licence plate if it was stored
                    if (storedLicencePlate) {
                        setLicencePlate(storedLicencePlate);
                        localStorage.removeItem(LICENCE_PLATE_KEY);
                    }
                    // Clear the stored vehicle ID
                    localStorage.removeItem(VEHICLE_KEY);
                    // Process the vehicle and go to step 2
                    await processVehicleType(Number(storedVehicleId));
                    return; // Exit early, don't check for share code
                }
                else {
                    removeLocalStorageKeys();
                }
                // If no stored vehicle, check for share code
                const urlParams = new URLSearchParams(window.location.search);
                const shareCode = ref(urlParams.get('shareCode'));
                if (shareCode.value) {
                    getSharedRecommendationData(shareCode.value);
                }
            }
        });
        const removeLocalStorageKeys = () => {
            localStorage.removeItem(VEHICLE_KEY);
            localStorage.removeItem(LICENCE_PLATE_KEY);
        };
        async function getSharedRecommendationData(shareCode) {
            const sharedRecommendationData = await api.getSharedRecommendations(shareCode);
            if (sharedRecommendationData.data.licence_plate) {
                setLicencePlate(sharedRecommendationData.data.licence_plate);
            }
            processVehicleType(sharedRecommendationData.data.vehicle_type_id);
        }
        async function processVehicleType(vehicleId) {
            const response = await api.getProductRecommendations(vehicleId);
            setVehicleDetails(response.data.vehicle);
            setVehicleComponents(response.data.recommendations);
            // Increment the key to force re-render
            vehicleKey.value++;
            goToStep(2);
        }
        // Handle vehicle change from edit overlay
        async function handleVehicleChanged(vehicleTypeId) {
            // Reuse the existing processVehicleType function to fetch new product data
            await processVehicleType(vehicleTypeId);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(step) == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(SearchTabPanels, { onVehicleChanged: handleVehicleChanged }),
                        _createVNode(InfoMessage),
                        _createVNode(VehicleTypesList),
                        _createVNode(StaticBanner),
                        _createVNode(StaticBannerWithCTA)
                    ]))
                    : _createCommentVNode("", true),
                (_unref(step) == 2)
                    ? (_openBlock(), _createElementBlock("div", { key: vehicleKey.value }, [
                        _createVNode(VehicleDetailsHeader, { onVehicleChanged: handleVehicleChanged }),
                        _createVNode(RecommendedVehicleComponents),
                        _createVNode(FindYourNearestStockistMap)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
